import { Temperature } from '../../core/models/temperature.model';

/**
 * Formats the temperature display for reefer loads.
 * @param temp - The temperature object containing min, max, and isContinuous properties.
 * @returns A formatted string for the temperature display or null if not applicable.
 */
export function formatTemperature(temp: Temperature): string | null {
  if (!temp) return null;
  const continuousText = temp.isContinuous ? ' ©' : '';
  if (temp.value) {
    return temp.value ? `${temp.value}°F${continuousText}` : null;
  }
  if (temp.min) {
    return temp.min ? `${temp.min}°F${continuousText}` : null;
  }
  if (temp.max) {
    return temp.max ? `${temp.max}°F${continuousText}` : null;
  }
  return `-- °F${continuousText}`;
}
